export default {
  footer: {
    telegram: "FAQ",
    aboutDfuse: "中数文联盟链区块浏览器",
    copyright: "© {{year}} 中数文科技有限公司",
    privacyPolicy: "Privacy Policy",
    privacyPolicyLink: "https://zhongshuwen.com/help-block-explorer",
    termsOfServices: "Terms of Service",
    termsOfServicesLink: "https://zhongshuwen.com/help-block-explorer-terms"
  }
}
